import React from 'react';

import CourseTable from '../Table';

import { useStyles } from './styles';

export default () => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <CourseTable />
    </div>
  );
};
